<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :center="true"
      title="充值还款"
      :visible.sync="payVisible"
      fullscreen
      :before-close="fanhui"
    >
      <div class="js-neirong">
        <div class="swpay-content">
          <div class="js-mbinfo">
            <span>顾客姓名: {{member.memberName}}</span>
          </div>
          <div class="swpay-left">
             <div style="height: 380px;">
               <div class="consumption">
                 <span class="yi-left">欠款金额:</span>
                 <span class="yi-right" style="text-align: center;color: #ee0a24">{{amount}}</span>
               </div>
               <div class="discount">
                 <span class="yi-left">会员名称:</span>
                 <div class="yi-right">
                   <el-select v-model="mcId" placeholder="请选择" size="mini" class="shurukuang" @change="setMc(mcId)">
                     <el-option
                       v-for="item in memberCards"
                       :key="item.id"
                       :label="item.cardName+' - '+item.deptName"
                       :value="item.id">
                     </el-option>
                   </el-select>
                 </div>
               </div>
               <div class="discount">
                 <span class="yi-left">充值金额:</span>
                 <span class="yi-right" style="color: #e82742;">
                   <el-input-number v-model="totalAmount" :disabled="mc.changeAmount==1" :min="0" size="mini" class="shurukuang"></el-input-number>
                  </span>
               </div>
               <div class="discount">
                 <span class="yi-left">赠送金额:</span>
                 <span class="yi-right" style="color: #e82742">
                <el-input-number v-model="giveAmount" :disabled="mc.changeAmount==1" :min="0" size="mini"class="shurukuang"></el-input-number>
              </span>
               </div>
               <div class="discount">
              <span class="yi-left">
                 <el-radio v-model="radio" :label="1">开单</el-radio>
                  <el-radio v-model="radio" :label="2" v-if="checkPermission('bdqx')">补单</el-radio>
              </span>
                 <span class="yi-right" style="color: #e82742">
                 <el-date-picker
                   v-if="radio==2"
                   size="small"
                   value-format="yyyy-MM-dd HH:mm:ss"
                   v-model="kdDate"
                   type="datetime"
                   placeholder="选择日期时间">
                 </el-date-picker>
              </span>
               </div>
               <div class="emp-discount">
                 <div>
                   <span class="emp-name">选择人员:</span>
                   <el-select v-model="station" placeholder="选择岗位" size="mini" clearable  @change="setStation" style="width: 190px">
                     <el-option
                       v-for="item in gws"
                       :key="item.value"
                       :label="item.name"
                       :value="item.value">
                     </el-option>
                   </el-select>
                   <el-select
                     style="margin-left: 5px;width: 190px"
                     size="mini"
                     v-model="empIds"
                     multiple
                     collapse-tags
                     @change="addEmp"
                     placeholder="请选择员工"
                   >
                     <el-option
                       v-for="item in emps"
                       :key="item.id"
                       :label="item.nickName"
                       :value="item.id">
                     </el-option>
                   </el-select>
                 </div>
                 <div class="emp-list">
                   <div class="emp-item" v-for="item in empitems">
                     <!--                  <span style="width: 30px"><i class="el-icon-remove-outline" style="cursor: pointer"></i></span>-->
                     <span style="width: 262px">员工名称:<span style="margin-left: 18px">{{item.empName}}</span></span>
                     <span>
                    业绩:
                    <span style="margin-left: 3px"><el-input-number v-model="item.ach" :min="0" size="mini"
                                                                    style="width: 152px;"></el-input-number></span>
                  </span>
                   </div>
                 </div>
               </div>
             </div>
            <div class="swpay-choice">
              <span style="width: 130px;padding-left: 40px;line-height: 70px">支付方式:</span>
              <div class="mode">
                <div class="mode1">
                  <div
                    style="cursor: pointer"
                    class="icon"
                    v-for="(item, index) of iconList"
                    :key="index"
                    @click="changeList(item.type, item.iconDec)"
                  >
                    <img class="imgfont" :class="{ checked: item.type == iconIndex }" :src="item.iconContent">
                    <p class="iconDec">{{ item.iconDec }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="js-liushui">
          <div class="js-liushui-bt"> 收钱吧支付成功，本系统未结算列表</div>
          <el-table :data="pays" v-if="pays.length>0">
            <el-table-column prop="paySn" label="收钱吧单号"/>
            <el-table-column prop="totalPrice" label="金额" width="100"/>
            <el-table-column prop="payTime" label="支付时间"/>
            <el-table-column prop="name" label="类型" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.payType==3">微信</span>
                <span v-if="scope.row.payType==4">支付宝</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="setPay(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="payment-footer">
        <el-button type="primary" class="settlement" :loading="isDisabled" @click="toSaveOrder(iconIndex)">
          {{isDisabled==true?'结算中':'结算'}}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      center
      title="提示"
      :visible.sync="titleVisible"
      width="15%"
      :before-close="closeTitel"
    >
      <div
        style="margin: 0 auto; text-align: center; width: 100%; height: 100%"
      >
        <span style="font-weight: bold; font-size: 18px">{{
          titleContent
        }}</span>
      </div>
      <br/>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      center
      :title="zfTitle"
      :visible.sync="ptVisible"
      width="400px"
      :before-close="closeCode"
    >
      <div style="margin: 0 auto; text-align: center; width: 100%; height: 100%;margin-top: -20px">
        <el-input v-model="dynamicId" size="mini" ref="dynamic" style="width: 260px;display: block;margin: auto"
                  placeholder="请输入内容"></el-input>
        <img :src="qrCode" style="width: 150px;height: 150px;">
      </div>
    </el-dialog>


    <el-dialog title="提示" :visible.sync="paysVisible" width="300px" center>
      <div class="del-dialog-cnt" style="font-size: 15px">是否选择此支付记录进行结算？</div>
      <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="paysVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="mcRecharge">确 定</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
  import {getToken} from "../../../utils/auth";

  export default {
    name: "czhk",
    data() {
      return {
        hkRadio:1,
        mcId:'',
        mc: {},
        timer: null,
        dynamicId: "",
        iconIndex: 2,
        iconList: [
          {
            iconContent: require("../../../assets/images/xj.png"),
            iconDec: "现金",
            type: "2",
            balance: "",
          },
          {
            iconContent: require("../../../assets/images/wx.png"),
            iconDec: "微信",
            type: "3",
            balance: "",
          },
          {
            iconContent: require("../../../assets/images/zfb.png"),
            iconDec: "支付宝",
            type: "4",
            balance: "",
          },
        ],

        totalAmount: 0,
        giveAmount: 0,
        amount: 0,

        gws: [],
        emps: [],
        fEmps: [],
        sEmps: [],
        tEmps: [],
        station: '',
        empIds: '',
        empitems: [],


        isDisabled: false,

        zfTitle: '',
        paySn: "",
        payNo: "",
        qrCode: "",
        ptVisible: false,
        alPay: '',
        titleContent: "",
        titleVisible: false,


        isSqb: '',
        paysVisible: false,
        pays:[],

        kdDate: '',
        radio: 1,
      };
    },
    props: {
      payVisible: Boolean,
      qk:Number,
      memberCards:Array,
      member:Object,
      qkIds:Array,
    },
    watch: {
      dynamicId(val) {
        if (val != null && val.length == 18) {
          this.payMethod(this.totalAmount, this.iconIndex);
        }
      },
    },
    created() {
      this.amount=this.qk
      this.totalAmount=this.amount
      this.getEmpList()
      this.getDept()
      if (this.memberCards.length>0){
        this.mcId=this.memberCards[0].id
        this.mc=this.memberCards[0]
      }
    },
    destroyed() {
      // 在页面销毁后，清除计时器
      this.beforeDestroy()
    },
    methods: {
      async getDept() {
        let res = await this.$get("/sw/getSwDept", {token: getToken()});
        this.isSqb = res.dept.isSqb
        if (res.dept.isBtn == 0) {
          this.iconList.push(
            {
              iconContent: require("../../../assets/images/sjia.png"),
              iconDec: "商家",
              type: "9",
              balance: "",
            },
          )
        }
      },
      async getSyPayRecords(index) {
        let res = await this.$get("/sw/getSyPayRecords", {token: getToken(), payType: index});
        this.pays = res.list
      },
      setMc(mcId){
        this.mcId=mcId
        this.memberCards.forEach(item=>{
          if (mcId==item.id){
            this.mc=item
            return
          }
        })
      },
      addEmp(val) {
        var ids = val
        if (this.empitems.length < ids.length) {
          let id = ids.slice(-1);
          let tcxm = this.emps.find(it => {
            return it.id == id
          })
          let item = {
            employeeId: tcxm.id,
            empName: tcxm.nickName,
            gradeId: tcxm.gradeId,
            station: this.station,
            quantity: 1,
            ach: this.totalAmount,
          }
          this.empitems.push(item)
        } else {
          this.empitems = this.empitems.filter(x => ids.some(y => y === x.employeeId))
        }
      },

      //获取员工列表
      async getEmpList() {
        let res = await this.$get("/sw/getSwEmpList", {token: getToken()});
        this.fEmps = res.fEmps;
        this.sEmps = res.sEmps;
        this.tEmps = res.tEmps;
        if (res.fName) {
          this.gws.push({'name': res.fName, "value": 1,})
        }
        if (res.sName) {
          this.gws.push({'name': res.sName, "value": 2,})
        }
        if (res.tName) {
          this.gws.push({'name': res.tName, "value": 3,})
        }
      },
      setStation() {
        this.empitems = []
        this.empIds = []
        if (this.station == 1) {
          this.emps = this.fEmps
        }
        if (this.station == 2) {
          this.emps = this.sEmps
        }
        if (this.station == 3) {
          this.emps = this.tEmps
        }
      },

      closeTitel() {
        this.titleVisible = false;
      },

      closeCode() {
        this.ptVisible = false;
        this.beforeDestroy()
      },


      closePay() {
        this.$emit("successRecharge",{mcId:this.mcId});
      },
      fanhui() {
        this.$emit("closeRecharge");
      },
      async changeList(index) {
        this.iconIndex = index;
        this.pays = []
        if (index == 3 || index == 4) {
          this.getSyPayRecords(index)
        }
      },

      async toSaveOrder(iconIndex) {
        if (this.amount>this.totalAmount){
          this.$message.error("支付金额要大于欠款总金额!")
          return;
        }
        if (iconIndex==3||iconIndex==4){
          if (this.isSqb == 0) {
            this.toPay(iconIndex, this.totalAmount)
            return;
          }
        }
        this.mcRecharge()
      },

      //选择使用的支付记录
      setPay(item) {
        if (this.amount>=this.totalAmount){
          this.$message.error("支付金额要大于欠款总金额!")
          return;
        }
        this.payNo = item.payNo
        if (this.iconIndex == 3 || this.iconIndex == 4) {
          if (parseFloat(item.totalPrice) != parseFloat(this.totalAmount)) {
            this.$message.error('金额不统一,无法选择结算！');
            return;
          }
          this.paysVisible = true
        }
      },

      async mcRecharge() {
        let ach = 0;
        this.empitems.forEach(item => {
          ach = parseFloat(ach + item.ach)
        })
        if (ach > this.totalAmount) {
          this.$message.error("员工业绩大于充值金额!")
          return;
        }
        if (this.radio==2&&!this.kdDate){
          this.$message.error('请选择补单时间!');
          this.isDisabled = false
          return;
        }
        this.isDisabled = true
        let data = {
          mcId: this.mc.id,
          mcName: this.mc.cardName,
          xkCmn: this.mc.xkCmn,
          empitems: JSON.stringify(this.empitems),
          totalAmount: this.totalAmount,
          giveAmount: this.giveAmount,
          payType: this.iconIndex,
          qkStr:JSON.stringify(this.qkIds),
          czType:'czhk',
          kdType: this.radio,
          kdDate: this.kdDate,
          token: getToken()
        };
        let res = await this.$post("/sw/mcRecharge", data);
        if (res.code == 200) {
          this.isDisabled = false
          this.closePay()
        } else {
          this.isDisabled = false
          this.$message.error(res.message);
        }
      },

      async toPay(status, totalPrice) {
        if (status == 3 || status == 4) {
          if (status == 3) {
            this.zfTitle = '微信支付'
          }
          if (status == 4) {
            this.zfTitle = '支付宝支付'
          }
        }
        this.titleContent = '请您扫码支付'
        let data = {
          token: getToken(),
          payType: status,
          payName: "会员卡充值",
          orderId: '',
          totalPrice: totalPrice,
        };
        let res = await this.$post("/sw/precreate", data);
        this.isDisabled = false
        if (res.code == 200) {
          this.payType = status;
          this.qrCode = res.qrCode;
          this.payNo = res.payNo;
          this.beforeDestroy();
          this.dataRefreh();
          this.ptVisible = true;
          this.$nextTick(() => {
            this.$refs.dynamic.focus() // 设置焦点
          })
        } else {
          this.$message.error(res.message)
        }
      },

      // 定时刷新数据函数
      dataRefreh() {
        // 计时器正在进行中，退出函数
        if (this.timer != null) {
          return;
        }
        // 计时器为空，操作
        this.timer = setInterval(() => {
          this.getPayStatus(); //加载数据函数
        }, 3000);
      },

      // 停止定时器
      beforeDestroy() {
        clearInterval(this.timer); //清除计时器
        this.timer = null; //设置为null
      },

      async getPayStatus() {
        let data = {
          token: getToken(),
          payNo: this.payNo,
        };
        let res = await this.$get("/sw/getPayStatus", data);
        if (res.code == 200) {
          this.titleContent = res.message;
          this.mcRecharge()
          this.beforeDestroy();
        } else {
          this.$message.error("正在支付中")
        }
      },

      async payMethod(totalPrice, payType) {
        if (!this.dynamicId) {
          this.$message.error("请扫付款码");
          return;
        }
        let data = {
          token: getToken(),
          dynamicId: this.dynamicId,
          payType: payType,
          payName: "会员卡充值",
          orderId:'',
          totalPrice: totalPrice,
        };
        let res = await this.$post("/sw/payMethod", data);
        if (res.code == 200) {
          this.payNo = res.payNo
          this.beforeDestroy();
          this.dataRefreh();
        } else {
          this.$message.error(res.message);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

    .swpay-left {
      width: 100%;
      height: 100%;
    }

    .yi-left {
      width: 40%;
      display: inline-block;
      font-size: 14px;
    }

    .emp-name {
      width: 68px;
      display: inline-block;
      font-size: 14px;
    }

    .yi-right {
      display: inline-block;
      width: 30%;
      text-align: right;
    }

  .swpay-choice {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    border-bottom: #ececec solid 1px;
    height: auto;
    .mode {
      width: 100%;
      display: flex;
    }
  }

  .consumption,
  .discount {
    height: 40px;
    line-height: 40px;
    padding-left: 40px;
    border-bottom: #ececec solid 1px;
    color: #666666;
  }

  .emp-discount {
    height: 238px;
    line-height: 40px;
    padding-left: 40px;
    border-bottom: #ececec solid 1px;
    color: #666666;
    display: flex;
    flex-direction: column;
  }

  .emp-list {
    margin-top: 6px;
    height: 188px;
    overflow: scroll;
  }

  .emp-item {
    height: 32px;
    line-height: 32px;
    margin-bottom: 3px;
    display: flex;
    flex-direction: row;
  }

  //支付方式
  .mode1 {
    .icon {
      width: 55px;
      height: 70px;
      line-height: 40px;
      float: left;
      margin-top: 5px;
      text-align: center;

      .imgfont {
        width: 35px;
        height: 35px;
      }
    }

    .imgfont.checked {
      border-radius: 50%;
      border: #eb2742 solid 1px;
      background-color: #eb2742;
      color: #fff;
    }
  }

  .payment-footer {
    width: 100%;
    height: 15%;

    .settlement {
      width: 100%;
      height: 50px;
      border: 0;
      background-color: #eb2742;
      cursor: pointer;
      color: #fff;
    }
  }

  .iconDec {
    width: 55px;
    margin-top: -20px;
    font-size: 13px;
  }
  .xuanxiang{
    height: 45px;
    line-height: 45px;
  }
  .shurukuang{
    width: 250px;
    display: block;
    margin: auto
  }
</style>
